import _ from 'lodash';
import { useDispatch } from 'react-redux';

import { surveyMakeDuplicate, surveyMakePrivate, surveysDeleteById, updateSurvey } from 'api/endpoints/survey';
import { ENUM_SURVEY_STATUS } from 'constants/enum';
import { TEXT_SURVEY_LIST } from 'constants/string/texts';
import { toastError, toastSuccess } from 'lib/toast';
import { setLoading } from 'store/actions/common';

const useSurvey = () => {
  const dispatch = useDispatch();

  /**
   * makePrivate
   * Description: This function convert from the public state to the private of Survey
   * @param {*} id
   * @returns
   */
  const makePrivate = async (id) => {
    dispatch(setLoading({ isOpen: true }));
    return surveyMakePrivate(id)
      .then((response) => {
        dispatch(setLoading({ isOpen: false }));
        toastSuccess(response?.message);
        return true;
      })
      .catch((error) => {
        dispatch(setLoading({ isOpen: false }));
        toastError(error.message);
        throw error;
      });
  };

  /**
   * revertPublic
   * Description: This function convert from the private state to the public of Survey
   * Note:
   *  - Switch from private status to public, we retain Survey Private and
   *      create a public voucher from this Survey Private
   *  - The purpose to save the history of Survey responded on the client
   * @param {*} id
   * @returns
   */
  const revertPublic = async (id, title) => {
    dispatch(setLoading({ isOpen: true }));
    return surveyMakeDuplicate(id, { title: title, status: ENUM_SURVEY_STATUS.PUBLIC })
      .then((response) => {
        dispatch(setLoading({ isOpen: false }));
        toastSuccess(response?.message);
        return response;
      })
      .catch((error) => {
        dispatch(setLoading({ isOpen: false }));
        toastError(error.message);
        throw error;
      });
  };

  const deleteSurvey = async (id) => {
    dispatch(setLoading({ isOpen: true }));
    return await surveysDeleteById(id)
      .then(async () => {
        toastSuccess(`1${TEXT_SURVEY_LIST.SELECTED_DELETED}`);
        dispatch(setLoading({ isOpen: false }));
      })
      .catch((error) => {
        toastError(error?.message);
        dispatch(setLoading({ isOpen: false }));
        throw error;
      });
  };

  /**
   * makePublic
   * Description: This function convert from the draft state to the public of Survey
   * @param {*} id
   * @returns
   */
  const makePublic = (id, data) => {
    const newData = _.cloneDeep(data);
    delete newData.sections;
    delete newData.id;
    newData.status = ENUM_SURVEY_STATUS.PUBLIC;
    dispatch(setLoading({ isOpen: true }));
    return updateSurvey(id, newData)
      .then((response) => {
        toastSuccess(response?.message);
        dispatch(setLoading({ isOpen: false }));
        return true;
      })
      .catch((error) => {
        toastError(error?.message);
        dispatch(setLoading({ isOpen: false }));
        throw error;
      });
  };

  return { makePrivate, revertPublic, deleteSurvey, makePublic };
};

export default useSurvey;
